import { useCallback } from "react";
import { IEconomicActivityList } from "../../application/models/IEconomicActivityList";
import { useAxiosInstances } from "../axios-instance";

export const useEconomicActivityListApi = () => {
  const { axiosAuthInstance } = useAxiosInstances();

  const createEconomicActivityListApi = useCallback(
    async (data: {
      createdBy: string;
      name: string;
      economicActivityList?: string[];
    }): Promise<IEconomicActivityList> => {
      try {
        const result = await axiosAuthInstance.post(
          "/routes/economic-activity-list/",
          data, 
        );
        return result.data.result.economicActivityList
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance],
  );

    const findEconomicActivityListByIdApi = useCallback(
    async (id: string): Promise<IEconomicActivityList> => {
      try {
        const result = await axiosAuthInstance.get(
          `/routes/economic-activity-list/list/${id}`,
        );
        return result.data.result.economicActivityList
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance],
  );

  const findEconomicActivityListsApi = useCallback(
    async (createdBy: string): Promise<IEconomicActivityList[]> => {
      try {
        const result = await axiosAuthInstance.get(
          `/routes/economic-activity-list/${createdBy}`,
        );
        return result.data.result.economicActivityList
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance],
  );

   const editEconomicActivityListApi = useCallback(
    async (data: {
      id: string
      createdBy: string;
      name: string;
      economicActivityList?: string[];
    }): Promise<IEconomicActivityList> => {
      try {
        const result = await axiosAuthInstance.put(
          `/routes/economic-activity-list/update/${data.id}`,
          data, 
        );
        return result.data.result.economicActivityList
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance],
  );

  const editStatusEconomicActivityListApi = useCallback(
    async (data: {
      id: string
      active: boolean
    }): Promise<IEconomicActivityList> => {
      try {
        const result = await axiosAuthInstance.put(
          `/routes/economic-activity-list/updateStatus/${data.id}`,
          data, 
        );
        return result.data.result.economicActivityList
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance],
  );

  return {
    createEconomicActivityListApi,
    findEconomicActivityListByIdApi,
    findEconomicActivityListsApi,
    editEconomicActivityListApi,
    editStatusEconomicActivityListApi,
  };  
};
